import React, { createContext, useEffect, useState, } from 'react';
import { Routes, Route, useLocation, Navigate, } from 'react-router-dom';

import './App.css';
import { makeStyles, } from "@fluentui/react-components";
import Dashboard from './pages/Dashboard';
import ExtractPage from './pages/ExtractPage';
import Customer from './pages/Customer';
import WidgetPage from './pages/WidgetPage';
import Sitemap from './pages/Sitemap';
import MasterPage from './pages/MasterPage';
import Header from './parts/Header';
import ExtractDetail from './pages/ExtractDetail';
import CosmeWidgetAPIClient from './library/CosmeWidgetAPIClient';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { LoginPage } from './pages/LoginPage';
import JobPage from './pages/JobPage';
import PageLoading from './parts/PageLoading';

const useStyles = makeStyles({
  app: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr auto",
    width: "100vw",
    height: "100vh",
  },
  main: {
    height: "calc(100% - 70px)",
  }
});

export const CWClientContext = createContext<CosmeWidgetAPIClient>(null as unknown as CosmeWidgetAPIClient);
export const UserProfile = createContext<any>(null as unknown as any);

function App() {
  const styles = useStyles();
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const location = useLocation();
  const [cwClient, setCwClient] = useState<CosmeWidgetAPIClient>(null as unknown as CosmeWidgetAPIClient);


  useEffect(() => {
    if (account) {
      instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: account
      }).then((response) => {
        if (response) {
          setCwClient(new CosmeWidgetAPIClient(response.accessToken));
        }
      });
    }
  }, [instance, account]);


  // authentication check and redirect login page.
  if (!isAuthenticated && location.pathname !== '/login/') {
    console.log("not authenticated.", isAuthenticated);
    sessionStorage.setItem("currentPage", location.pathname);
    return (
      <Navigate to='/login/' replace />
    )
  } else if (!isAuthenticated && location.pathname === '/login/') {
    console.log("not authenticated. view Login page");
    return (<LoginPage></LoginPage>)
  } else if (isAuthenticated && location.pathname === '/login/') {
    let currentPage: string | null = sessionStorage.getItem("currentPage");
    console.log("authenticated. view current page", currentPage);
    if (currentPage !== null) {
      return (
        <Navigate to={currentPage} replace />
      );
    } else {
      return (
        <Navigate to="/" replace />
      );
    }
  } else {
    sessionStorage.removeItem("currentPage");
  }
  if(cwClient === null) {
    return <PageLoading message="ログイン中" />
  }

  return (
    <>
      <AuthenticatedTemplate>
        <UserProfile.Provider value={null as unknown as any}>
          <CWClientContext.Provider value={cwClient}>
            <div className={styles.app}>
              <Header
              />
              <div className={styles.main}>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path='extract'>
                    <Route path="a/:archiveId" element={<ExtractDetail />} />
                    <Route path="" element={<ExtractPage />} />
                  </Route>
                  <Route path='/login' element={<LoginPage />} />
                  <Route path='/customer' element={<Customer />} />
                  <Route path='/master' element={<MasterPage />} />
                  <Route path='/sitemap' element={<Sitemap />} />
                  <Route path='/widget' element={<WidgetPage />} />
                  <Route path='/job' element={<JobPage />} />
                </Routes>
              </div>
            </div>
          </CWClientContext.Provider >
        </UserProfile.Provider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage></LoginPage>
      </UnauthenticatedTemplate>
    </>


  );
};

export default App;
